var map = {
	"./activities.svg": 54,
	"./cafe.svg": 55,
	"./christmas.svg": 56,
	"./dinner.svg": 57,
	"./entertainment.svg": 58,
	"./events.svg": 59,
	"./family.svg": 60,
	"./four.svg": 61,
	"./gift_card.svg": 62,
	"./independant.svg": 63,
	"./lunch.svg": 64,
	"./nightclubs.svg": 65,
	"./one.svg": 66,
	"./pubs_bars.svg": 67,
	"./shopping.svg": 68,
	"./sweet_treat.svg": 69,
	"./three.svg": 70,
	"./two.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;